<template>
  <div class="sidebar">
      <div class="admin-logo">
          <!--<i class="fas fa-brain logo-icon"></i>-->
          <img style="height: 25px; width: auto;" src="@/assets/topLogo.png"/>
          <h1>识心智能管理平台</h1>
      </div>
    
    <div class="sidebar-menu">
      <a 
        href="#" 
        class="menu-item" 
        :class="{ active: activeMenu === 'dashboard' }"
        @click="changeMenu('dashboard')"
      >
        <i class="fas fa-home"></i>
        <span>控制面板</span>
      </a>
      <a 
        href="#" 
        class="menu-item"
        :class="{ active: activeMenu === 'edu-appointment' }"
        @click="changeMenu('edu-appointment')"
      >
        <i class="fas fa-graduation-cap"></i>
        <span>教育预约管理</span>
      </a>
      <a 
        href="#" 
        class="menu-item"
        :class="{ active: activeMenu === 'sound-appointment' }"
        @click="changeMenu('sound-appointment')"
      >
        <i class="fas fa-music"></i>
        <span>音疗预约管理</span>
      </a>
      <a 
        href="#" 
        class="menu-item"
        :class="{ active: activeMenu === 'user-management' }"
        @click="changeMenu('user-management')"
      >
        <i class="fas fa-users"></i>
        <span>用户管理</span>
      </a>
      <a 
        href="#" 
        class="menu-item"
        :class="{ active: activeMenu === 'system-settings' }"
        @click="changeMenu('system-settings')"
      >
        <i class="fas fa-cog"></i>
        <span>系统设置</span>
      </a>
      <a href="#"
         class="menu-item"
         @click="showLogoutModal">
              <i class="fas fa-sign-out-alt"></i>
              <span>退出登录</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    activeMenu: {
      type: String,
      default: 'dashboard'
    }
  },
  methods: {
    changeMenu(menu) {
      this.$emit('menu-change', menu)
    },
    showLogoutModal() {
        this.$emit('logout');
    }
  }
}
</script>